import { useState, useCallback } from 'react';
import {
  UpdateWizardState,
  UpdateWizardStep,
  EntityType,
  UpdateOperation,
} from './types';

export const useUpdateWizard = () => {
  const [state, setState] = useState<UpdateWizardState>({
    currentStep: UpdateWizardStep.SELECT_ENTITY,
    selectedEntity: null,
    selectedEntityData: null,
    updates: [],
    relatedUpdates: [],
    productEntity: [],
    loading: false,
    error: null,
  });

  const setCurrentStep = useCallback((step: UpdateWizardStep) => {
    setState((prev) => ({ ...prev, currentStep: step }));
  }, []);

  const setSelectedEntity = useCallback((entity: EntityType | null) => {
    setState((prev) => ({
      ...prev,
      selectedEntity: entity,
      selectedEntityData: null,
      updates: [],
      relatedUpdates: [],
      productEntity: []
    }));
  }, []);

  const setSelectedEntityData = useCallback((data: Record<string, unknown> | null) => {
    setState((prev) => ({ ...prev, selectedEntityData: data }));
  }, []);

  const addProductEntity = useCallback((update: UpdateOperation) => {
    setState((prev) => ({
      ...prev,
      productEntity: [...prev.productEntity.filter((u) => u.entityId !== update.entityId), update],
    }));
  }, []);

  const addUpdate = useCallback((update: UpdateOperation) => {
    setState((prev) => ({
      ...prev,
      updates: [...prev.updates.filter((u) => u.entityId !== update.entityId || u.entityType !== update.entityType), update],
    }));
  }, []);

  const addRelatedUpdate = useCallback((update: UpdateOperation) => {
    setState((prev) => ({
      ...prev,
      relatedUpdates: [
        ...prev.relatedUpdates.filter((u) => u.entityId !== update.entityId),
        update,
      ],
    }));
  }, []);

  const setLoading = useCallback((loading: boolean) => {
    setState((prev) => ({ ...prev, loading }));
  }, []);

  const setError = useCallback((error: string | null) => {
    setState((prev) => ({ ...prev, error }));
  }, []);

  const clearError = useCallback(() => {
    setState((prev) => ({ ...prev, error: null }));
  }, []);

  const clearUpdates = useCallback(() => {
    setState((prev) => ({ ...prev, updates: [], relatedUpdates: [] }));
  }, []);

  const reset = useCallback(() => {
    setState({
      currentStep: UpdateWizardStep.SELECT_ENTITY,
      selectedEntity: null,
      selectedEntityData: null,
      updates: [],
      relatedUpdates: [],
      productEntity: [],
      loading: false,
      error: null,
    });
  }, []);

  return {
    state,
    loading: state.loading,
    error: state.error,
    currentStep: state.currentStep,
    selectedEntity: state.selectedEntity,
    selectedEntityData: state.selectedEntityData,
    updates: state.updates,
    relatedUpdates: state.relatedUpdates,
    produductEntity: state.productEntity,
    setCurrentStep,
    setSelectedEntity,
    setSelectedEntityData,
    addUpdate,
    addProductEntity,
    addRelatedUpdate,
    setLoading,
    setError,
    clearError,
    clearUpdates,
    reset,
  };
};
